<template>
  <div class="home" style="margin-bottom:51px !important;
    overflow: scroll;    margin-top: -11px;">
   
    <detl></detl>
  </div>
  
  
</template>

<script>
// @ is an alias to /src
// import offr from '@/components/Items'
import detl from '@/components/Itemview'
import axios from 'axios';

export default {
   components: {      
        // offr,
        detl,
        
       },
        data: () => ({
            name: 'Item Details',
            products : []
        }),
        mounted() {
           
            this.$parent.$children[0].$parent.ttlval = this.name

            // console.log(this.$el.textContent) 

       },
    

 
}
</script>
